import { dbCan, type Database, isDatabaseOwner } from '@/entities/database';

/**
 * What the viewer may take out to a file - the same rule the server enforces (it decides): a
 * confidential database only its owner, a normal one with records its owner or whoever manages the
 * structure, structure only any viewer.
 */
export function exportRights(database: Database): { structure: boolean; records: boolean } {
  if (!database.content_visible) return { structure: false, records: false };
  const owner = isDatabaseOwner(database);
  if (database.is_confidential) return { structure: owner, records: owner };
  return { structure: true, records: owner || dbCan(database, 'database.manage_structure') };
}
